import * as configConstants from './configConstants';


export const onGeoConfigLoaded = geoConfig => {

    return {
        payload: geoConfig,
        type: configConstants.ACTION_GEO_CONFIG_LOADED
    };
};


export const onGeoConfigLoading = geoConfig => {

    return {
        payload: geoConfig,
        type: configConstants.ACTION_GEO_CONFIG_LOADING
    };
};


export const onGlobalConfigLoaded = globalConfig => {

    return {
        payload: globalConfig,
        type: configConstants.ACTION_GLOBAL_CONFIG_LOADED
    };
};


export const onGlobalConfigLoading = () => {

    return {
        payload: {},
        type: configConstants.ACTION_GLOBAL_CONFIG_LOADING
    };
};


export const onUserConfigLoaded = userConfig => {

    return {
        payload: userConfig,
        type: configConstants.ACTION_USER_CONFIG_LOADED
    };
};


export const onUserConfigLoading = () => {

    return {
        payload: {},
        type: configConstants.ACTION_USER_CONFIG_LOADING
    };
};

